module.exports = __webpack_public_path__ + "static/media/ann.8b16c4ac.jpg";